module.exports = __webpack_public_path__ + "static/media/phone-rotary.2daf31ba.svg";